<template>
  <!-- <div class="the-empty">
    <img class="img-view" alt="" src="@/assets/images/person/Nulldata.png">
    <slot></slot>
    <p class="p-view" v-if="text">{{ text }}</p>
  </div> -->
  <div class="notFound">
		<div class="not-pic"></div>
		<div class="not-title">{{text}}</div>
	</div>
</template>

<script>
export default {
  name: "emptyPage",
  props: {
    text: {
      type: String,
      default: "暂无数据"
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './emptyPage.scss'
// .the-empty {
//   width: 100%;
//   //min-height: 12rem;
//   text-align: center;
//   user-select: none;
//   //padding: 24px 0;
//   overflow: hidden;
//   background-color: #FFFFFF;
//   img {
//     width: 1.7rem;
//     height: 100%;
//     margin: 0 auto;
//     margin-top: 0.5rem;
//   }
//   p {
//     line-height: 0.2rem;
//     height: 0.2rem;
//     font-size: 0.14rem;
//     font-family: PingFang-SC-Medium, PingFang-SC;
//     font-weight: 500;
//     color: #323232;
//     margin-top: 0.3rem;
//   }
// }
</style>